import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, Fragment } from 'react';
import { Pane } from '../Pane';
import { Media, SingleObjectMedia } from '../Media';
import { connect } from 'react-redux';
import { selectLayoutState } from '../../store/selectors';
import { ReportImage } from '../ReportImage';
import { BirdActionMenu } from '../BirdActionMenu';
import { ReportContextMenu } from '../ReportContextMenu';
import { HiddenSectionDialog } from '../HiddenSectionDialog';
import { ReportContextMenuState } from '../../store/reportContextMenu/ReportContextMenuState';
import { bindActionCreators } from 'redux';
import { useContextMenuHandlers } from '../hooks';
import { LoadingText } from './LoadingText';
import { exposeTestId } from '../../config';
import { ExplanationInfoDialog } from '../ExplanationInfoDialog';
import { ManageColumnsDialog } from '../ManageColumnsDialog';
//css
import cn from './ReportContainer.css.json';
const LoadingImage = (props) => {
    return (_jsxs(Fragment, { children: [_jsx("span", Object.assign({ style: { visibility: 'hidden', position: 'absolute' } }, { children: "Mg" })), _jsx(ReportImage, { host: props.url, reportUri: props.reportUri, objectName: props.objectName, authenticationType: props.authenticationType })] }));
};
export const ReportObjectContainerBase = ({ onReportObjectLoad, onContentComplete, objectName, authenticationType, objectHasError, isSingleObject, url, reportUri, reportLoaded, contentComplete, contextMenuActions, reportBackgroundColor, hideLoadImage, }) => {
    const [hasOnLoadFired, setHasOnLoadFired] = useState(false);
    const [hasContentCompleteFired, setHasContentCompleteFired] = useState(false);
    const showReportImage = !objectHasError && !contentComplete && reportLoaded !== 'reload' && !hideLoadImage;
    useEffect(() => {
        if (!hasOnLoadFired && onReportObjectLoad) {
            onReportObjectLoad();
            setHasOnLoadFired(true);
        }
        if (onContentComplete && contentComplete && !hasContentCompleteFired) {
            setHasContentCompleteFired(true);
            onContentComplete();
        }
    }, [
        hasOnLoadFired,
        onReportObjectLoad,
        hasContentCompleteFired,
        onContentComplete,
        contentComplete,
    ]);
    const media = isSingleObject ? (_jsx(SingleObjectMedia, { id: `media-${objectName}` })) : (_jsx(Media, { id: `media-${objectName}` }));
    const { onContextMenu, onKeyDown } = useContextMenuHandlers(contextMenuActions.open);
    if (showReportImage && url && reportUri && authenticationType) {
        return (_jsxs(Fragment, { children: [reportLoaded ? (_jsx("div", Object.assign({ style: { position: 'absolute', width: '100%', height: '100%', visibility: 'hidden' } }, { children: media }))) : undefined, _jsx(LoadingImage, { url: url, reportUri: reportUri, objectName: objectName, authenticationType: authenticationType })] }));
    }
    if (reportLoaded !== true) {
        return _jsx(LoadingText, {});
    }
    return (_jsxs(Pane, Object.assign({ className: cn.reportObject, onContextMenu: onContextMenu, onKeyDown: onKeyDown, style: { backgroundColor: reportBackgroundColor }, "data-testid": exposeTestId() ? 'reportObjectContainer' : undefined }, { children: [media, _jsx(ReportContextMenu, {}), _jsx(HiddenSectionDialog, { onContextMenu: onContextMenu }), _jsx(BirdActionMenu, {}), _jsx(ExplanationInfoDialog, {}), _jsx(ManageColumnsDialog, {})] })));
};
export const ReportObjectContainer = connect((state, props) => {
    var _a;
    const mediaId = `media-${props.objectName}`;
    const layoutState = selectLayoutState(state, mediaId);
    const warning = state.ui.warning[props.objectName];
    return {
        isSingleObject: !!(layoutState && layoutState.isSingleObject),
        objectHasError: warning ? warning.type === 'error' && !!warning.message : false,
        reportLoaded: state.transport.reportLoaded,
        contentComplete: state.transport.reportLoaded && state.transport.reportObjectContentComplete,
        reportBackgroundColor: (_a = state.bird.reportBackgroundColor) !== null && _a !== void 0 ? _a : undefined,
    };
}, (dispatch) => ({
    contextMenuActions: bindActionCreators(ReportContextMenuState.actions, dispatch),
}))(ReportObjectContainerBase);
